import AxiosInstance from "../Utils/axios/axiosConfig";

export const getPackagingDetails = async (value) => {
  const response = await AxiosInstance.get("packaging-config/");
  return response;
};

export const savePackagingDetails = async (body = {}) => {
  const response = await AxiosInstance.post(`packaging-config/`, body);
  return response;
};

export const updatePackagingDetails = async (itemId = "", body = {},) => {
  const response = await AxiosInstance.put(`packaging-config/?id=${itemId}`, body);
  return response;
};

export const deletePackaging = async (id) => {
  const response = await AxiosInstance.delete(`packaging-config/?id=${id}`);
  return response;
};